export class JournalRequest {
	date: number;
	description: string;
	entries: JournalEntryRequest[] = [];
	initial: boolean = false;
}

export class JournalEntryRequest {
	account: number;
	debit: number = 0;
	credit: number = 0;
}

export class JournalErrorResponse {
	description: string;
	name: string;
}